import cabecera from "./bloques/cabecera";
import desplegables from "./bloques/desplegables";
import lineaDeTiempo from "./bloques/linea_de_tiempo";
import testimonios from "./bloques/testimonios";
import imagenes from "./bloques/imagenes";
var bloques = function () {
    cabecera();
    desplegables();
    lineaDeTiempo();
    testimonios();
    imagenes();
};
export default bloques;
